module.exports = __webpack_public_path__ + "assets/img/5_1269_big.e50b2cce.jpg";